import { gql } from '@apollo/client';

// Updated mutation to accept individual fields
// Matches the structure used in handleSave in Product.js
const UPDATE_PRODUCT_MUTATION = gql`
  mutation UpdateProductMutation(
    $id: ID!, # Use ID! type
    # Include all mutable format-specific fields from Product model
    # Use camelCase argument names matching backend expectations
    $subtitle: String,
    $edition: String,
    $volume: String,
    $formatId: ID, # Use ID type for foreign key
    # $formatDetailId: String, # Removed - backend does not accept this
    $isbn: String,
    $retailPrice: Float,
    $inventory: Int, # Corresponds to inventoryQuantity frontend state
    $cartonQty: Int,
    $shipDate: Date, # Use Date type
    $publicationDate: Date, # Use Date type
    $weight: Float,
    $width: Float,
    $height: Float,
    $thickness: Float,
    $pageCount: Int,
    $adminNotes: String, # Use adminNotes (camelCase)
    $status: ID, # Status ID should be type ID
    $coverImage: String,
    $interiorImages: String, # JSON string of image URLs
    $audience: ID, # Audience ID
    $audienceDetails: String,
    $keySellingPoints: String,
    $marketing: String,
    $bisac: String # JSON string array of BISAC codes
    # Do NOT include productWork related fields (title, imprintId, seriesId, description)
    # Do NOT include creatorIds (handled by separate mutations)
  ) {
    updateProduct(
      id: $id,
      subtitle: $subtitle,
      edition: $edition,
      volume: $volume,
      formatId: $formatId, # Pass formatId (ID)
      # formatDetailId: $formatDetailId, # Removed
      isbn: $isbn,
      retailPrice: $retailPrice,
      inventory: $inventory,
      cartonQty: $cartonQty,
      shipDate: $shipDate, # Pass shipDate (Date)
      publicationDate: $publicationDate, # Pass publicationDate (Date)
      weight: $weight,
      width: $width,
      height: $height,
      thickness: $thickness,
      pageCount: $pageCount,
      adminNotes: $adminNotes, # Pass adminNotes (camelCase)
      status: $status,
      coverImage: $coverImage,
      interiorImages: $interiorImages,
      audience: $audience,
      audienceDetails: $audienceDetails,
      keySellingPoints: $keySellingPoints,
      marketing: $marketing,
      bisac: $bisac
    ) {
      # Request the updated product details to update cache/UI if needed
      product {
        id
        subtitle
        edition
        volume
        format {
          id
          description
        }
        # formatDetail field might not exist directly on Product model,
        # check backend schema if needed.
        # formatDetail {
        #    id
        #    description
        # }
        isbn
        retailPrice
        inventoryQuantity # Backend field name, check if returned
        cartonQty
        shipDate
        publicationDate
        weight
        width
        height
        thickness
        pageCount
        adminNotes
        status {
          id
          description
        }
        coverImage
        interiorImages
        audience {
          id
          description
        }
        audienceDetails
        keySellingPoints
        marketing
        bisac
        productWork { # Include ProductWork for context
            id
            title
        }
        # Add any other fields you might need refreshed in the UI
      }
      message # Keep message if the backend provides one
    }
  }
`;

export default UPDATE_PRODUCT_MUTATION;
